'use client';

var translations = {
    'View stats': 'Xem thống kê',
    'Competitive rate': 'Tỷ lệ cạnh tranh',
    'Analyzed using your application profile compared to other candidates applying for this job.': 'Được phân tích bằng cách sử dụng hồ sơ ứng tuyển của bạn so với các ứng viên khác đang ứng tuyển cho công việc này.',
    '/track-my-competitive-rate/': '/theo-doi-ty-le-canh-tranh-cua-toi/'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
